const NON_CONTENT_SELECTORS = 'style, script, noscript';
const STYLE_TAG_PATTERN = /<style[^>]*>[\s\S]*?<\/style>/gi;
const CSS_IMPORT_PATTERN = /@import[\s\S]*?;/gi;
const CSS_RULE_PATTERN = /[^{}]+?\{[^}]*\}/g;

const stripCssArtifacts = (input: string): string => {
  let result = input.replace(STYLE_TAG_PATTERN, '');
  result = result.replace(CSS_IMPORT_PATTERN, '');

  let prev = '';
  while (prev !== result) {
    prev = result;
    result = result.replace(CSS_RULE_PATTERN, '');
  }

  return result.replace(/\s+/g, ' ').trim();
};

export const getTextFromHtml = (html: string) => {
  const sanitized = stripCssArtifacts(html);
  const parser = new DOMParser();
  const doc = parser.parseFromString(sanitized, 'text/html');

  doc.querySelectorAll(NON_CONTENT_SELECTORS).forEach((node) => node.remove());

  const paragraphs = doc.querySelectorAll('p');

  paragraphs.forEach((p) => {
    p.replaceWith(' ' + p.textContent);
  });

  return doc.body.textContent || '';
};
